// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__JupF_","Button":"Contact_Button__1dtdp","Hours":"Contact_Hours__2Dv9z"};